/* global chrome */

export const pingExtension = (extensionId) => new Promise((resolve) => {
  if (typeof chrome === 'undefined' || !chrome.runtime) {
    resolve(false)
    return
  }
  if (!extensionId || typeof extensionId !== 'string') {
    resolve(false)
    return
  }
  try {
    chrome.runtime.sendMessage(extensionId, { action: 'PING' }, (response) => {
      if (chrome.runtime.lastError || !response?.success) {
        resolve(false)
      } else {
        resolve(true)
      }
    })
  } catch (e) {
    localStorage.removeItem('etherbuildr_extension_id')
    window.location.reload()
  }
})

export const syncPrintifySession = (extensionId) => new Promise((resolve, reject) => {
  if (typeof chrome === 'undefined' || !chrome.runtime) {
    reject(new Error('Chrome Extension not found.'))
    return
  }
  chrome.runtime.sendMessage(extensionId, { action: 'SYNC_PRINTIFY_SESSION' }, (response) => {
    if (chrome.runtime.lastError) {
      reject(new Error('Could not communicate with extension.'))
    } else if (!response?.success) {
      reject(new Error(response?.error || 'Session sync failed.'))
    } else {
      resolve(true)
    }
  })
})

export const scrapeEtsy = (extensionId, { designSeedId, url, callbackUrl, batchSize, imageModel }) => new Promise((resolve, reject) => {
  if (typeof chrome === 'undefined' || !chrome.runtime) {
    reject(new Error('Chrome Extension not found. Please install the EtherBuildr Chrome Extension.'))
    return
  }
  if (!extensionId || typeof extensionId !== 'string') {
    reject(new Error('Extension ID not configured. Please go to Settings and enter your Chrome Extension ID.'))
    return
  }
  chrome.runtime.sendMessage(extensionId, {
    action: 'SCRAPE_ETSY',
    designSeedId,
    url,
    callbackUrl,
    batch_size: parseInt(batchSize),
    image_model: imageModel || ''
  }, (response) => {
    if (chrome.runtime.lastError) {
      reject(new Error('Error: Could not communicate with extension.'))
    } else {
      resolve(response)
    }
  })
})
